// Generated from the Upzi DLS Figma icon library by sync-dls-icons.mjs.
import { createDlsIcon } from './dls-icon';

const CancelIcon = createDlsIcon('CancelIcon', {
  filled: (
    <>
      <path
        d="M24 4C12.954 4 4 12.954 4 24C4 35.046 12.954 44 24 44C35.046 44 44 35.046 44 24C44 12.954 35.046 4 24 4ZM31.561 29.439C32.147 30.025 32.147 30.974 31.561 31.56C31.268 31.854 30.884 32 30.5 32C30.116 32 29.732 31.854 29.439 31.561L24 26.121L18.561 31.56C18.268 31.854 17.884 32 17.5 32C17.116 32 16.732 31.854 16.439 31.561C15.853 30.975 15.853 30.026 16.439 29.44L21.879 24L16.44 18.561C15.854 17.975 15.854 17.026 16.44 16.44C17.026 15.854 17.975 15.854 18.561 16.44L24 21.879L29.439 16.44C30.025 15.854 30.974 15.854 31.56 16.44C32.146 17.026 32.146 17.975 31.56 18.561L26.121 24L31.561 29.439Z"
        fill="currentColor"
      />
    </>
  ),
  outline: (
    <>
      <path
        d="M24 42.5C34.2173 42.5 42.5 34.2173 42.5 24C42.5 13.7827 34.2173 5.5 24 5.5C13.7827 5.5 5.5 13.7827 5.5 24C5.5 34.2173 13.7827 42.5 24 42.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M30.5 17.5L17.5 30.5"
        stroke="currentColor"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.5 17.5L30.5 30.5"
        stroke="currentColor"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </>
  ),
});

export { CancelIcon };
export default CancelIcon;
